import { apiGet } from '@/store/api';
import { useApplicationStore } from '@/store/applicationStore';

export async function getWhiteBoards(agencyID: number) {
  const applicationStore = useApplicationStore();
  const data = await apiGet(`whiteboards/${agencyID}`);
  applicationStore.setWhiteBoards(data);
}
